"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATION_NOTES = exports.CONCEPT_NOTES = void 0;
const client_1 = require("@apollo/client");
exports.CONCEPT_NOTES = (0, client_1.gql) `
  query ConceptNotes($search: String, $limit: Int, $offset: Int) {
    restricted {
      conceptNotes(search: $search, limit: $limit, offset: $offset) {
        id
        createdAt
        updatedAt
        note
        userId
        conceptId
        concept {
          name
          entitlement {
            id
            name
          }
          topic {
            id
            name
          }
        }
      }
    }
  }
`;
exports.STATION_NOTES = (0, client_1.gql) `
  query StationNotes($search: String, $limit: Int, $offset: Int) {
    restricted {
      stationNotes(search: $search, limit: $limit, offset: $offset) {
        id
        createdAt
        updatedAt
        note
        userId
        stationId
        station {
          id
          name
          hiddenName
          entitlement {
            id
            name
          }
        }
      }
    }
  }
`;
